import Backbone from 'backbone';
import $ from 'jquery';
import React, {lazy, Suspense} from 'react';
import ReactDOM from 'react-dom/client';

import {Route} from 'notebook/protocols/Types';
import DatadogUtil from 'performance/DatadogUtil';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

const API_ID_PREFIX = 'prt_';

const MainPage = lazy(() => import(/* webpackChunkName: "protocols" */ 'notebook/protocols/MainPage'));

class ProtocolsRouter extends Backbone.Router {
  reactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.routes = {
      'protocols/:apiIdentifier/:vanity': 'protocol',
      'protocols/:apiIdentifier/:vanity/sbs': 'stepbystep',
      'protocols/:apiIdentifier/:vanity/edit': 'edit',
    };
  }

  renderPage(route: Route, params: {apiIdentifier: string}): void {
    this.reactRoot = renderToDOM(
      <Suspense fallback={<CenteredHorizontalThrobber />}>
        <MainPage navLinks={window.bootstrap!.navLinks!} route={route} params={params} />
      </Suspense>,
      $('.protocols-mount')[0],
      this.reactRoot
    );
  }

  protocol(apiIdentifier: string, vanity: string): void {
    DatadogUtil.startRUMView('protocol');
    this.renderPage('protocol', {
      apiIdentifier: API_ID_PREFIX + apiIdentifier,
    });
  }

  stepbystep(apiIdentifier: string, vanity: string): void {
    DatadogUtil.startRUMView('protocol_step_by_step');
    this.renderPage('stepbystep', {apiIdentifier: API_ID_PREFIX + apiIdentifier});
  }

  edit(apiIdentifier: string, vanity: string): void {
    DatadogUtil.startRUMView('protocol_edit');
    this.renderPage('edit', {apiIdentifier: API_ID_PREFIX + apiIdentifier});
  }
}
ProtocolsRouter.initClass();

export default ProtocolsRouter;
